// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
    width: 250px;
    background-color: #333;
    color: #fff;
    padding: 20px;
    height: 100vh;
}

.search {
    width: 100%;
    padding: 10px;
    margin-bottom: 20px;
    background-color: #444;
    border: none;
    border-radius: 5px;
    color: #fff;
}


.search:focus {
    outline: none;
    box-shadow: 0 0 0 2px #555;
    background-color: #4a4a4a;
}

.search::placeholder {
    color: #aaa;
}

.search-results {
    background-color: #444;
    border-radius: 5px;
    margin-top: -15px;
    padding: 10px;
    max-height: 200px;
    overflow-y: auto;
}

.search-results ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.search-results li {
    padding: 8px 10px;
    cursor: pointer;
    transition: background-color 0.2s;
}

.search-results li:hover {
    background-color: #555;
}

.search-results p {
    color: #aaa;
    text-align: center;
    padding: 10px;
}

nav ul {
    list-style: none;
    padding: 0;
}

nav ul li {
    padding: 10px 0;
    display: flex;
    align-items: center;
    font-size: 18px;
    transition: background-color 0.3s, color 0.3s;

}

nav ul li:hover {
    background-color: #555;

    color: #fff;

}

nav ul li i {
    margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/Sidebar.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;;;AAGA;IACI,aAAa;IACb,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,6CAA6C;;AAEjD;;AAEA;IACI,sBAAsB;;IAEtB,WAAW;;AAEf;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".sidebar {\n    width: 250px;\n    background-color: #333;\n    color: #fff;\n    padding: 20px;\n    height: 100vh;\n}\n\n.search {\n    width: 100%;\n    padding: 10px;\n    margin-bottom: 20px;\n    background-color: #444;\n    border: none;\n    border-radius: 5px;\n    color: #fff;\n}\n\n\n.search:focus {\n    outline: none;\n    box-shadow: 0 0 0 2px #555;\n    background-color: #4a4a4a;\n}\n\n.search::placeholder {\n    color: #aaa;\n}\n\n.search-results {\n    background-color: #444;\n    border-radius: 5px;\n    margin-top: -15px;\n    padding: 10px;\n    max-height: 200px;\n    overflow-y: auto;\n}\n\n.search-results ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.search-results li {\n    padding: 8px 10px;\n    cursor: pointer;\n    transition: background-color 0.2s;\n}\n\n.search-results li:hover {\n    background-color: #555;\n}\n\n.search-results p {\n    color: #aaa;\n    text-align: center;\n    padding: 10px;\n}\n\nnav ul {\n    list-style: none;\n    padding: 0;\n}\n\nnav ul li {\n    padding: 10px 0;\n    display: flex;\n    align-items: center;\n    font-size: 18px;\n    transition: background-color 0.3s, color 0.3s;\n\n}\n\nnav ul li:hover {\n    background-color: #555;\n\n    color: #fff;\n\n}\n\nnav ul li i {\n    margin-right: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
